import React, { useEffect, useState, useRef } from 'react';
import "./DropdownSmall.scss"

const DropdownSmall = ({
	optionsList = null,
	optionSelected = null,
	selectedHandler = null,
}) => {
	const dropdown = useRef()
	const [list, setList] = useState(null)
	const [selected, setSelected] = useState(null)
	const [open, setOpen] = useState(false)

	useEffect(() => {
		if(optionsList) setList(optionsList)
	}, [optionsList])

	useEffect(() => {
		setSelected(optionSelected)
		if(optionSelected && selectedHandler) selectedHandler(optionSelected.id)
	}, [optionSelected])

	const selectItem = (item) => {
		if(selectedHandler) selectedHandler(item.id ? item.id : item)
		if(item.id){
			const selectedItem = list.find(el => Number(el.id) === Number(item.id))
			if(selectedItem){
				setSelected(selectedItem)
			}
		} else {
			setSelected(item)
		}

		setOpen(false)
	}

	useEffect(() => {
		setTimeout(() => {
			document.addEventListener('click', documentClickHandlerDropdown);
		},[0])

		return () => document.removeEventListener('click', documentClickHandlerDropdown);
	}, []);

	const documentClickHandlerDropdown = (e) => {
		if(!dropdown.current) return;
		if(!dropdown.current.contains(e.target)){
			setOpen(false)
		}
	};

	return (
		<>
		{list &&
		<div className={"dropdown-small" + (open ? " open" : "") + (selected ? " status-"+selected.id : "")} ref={dropdown}>
			<div className="dropdown-small__btn" onClick={() => setOpen(!open)}>
				{selected ? selected.value : ''}
			</div>
			<div className="dropdown-small__list g-hide-scrollbar">
				{list.map((item) => {
					return(
						<button className={"dropdown-small__list-item" + (selected && Number(selected.id) === Number(item.id) ? " selected" : "")}
						onClick={() => selectItem(item)}
						key={item.id}>
							<div className="dropdown-small__list-item-inner">
								{item.value}
							</div>
						</button>
					)
				})
				}
			</div>
		</div>
		}
		</>
	);
};

export default DropdownSmall;
